// extracted by mini-css-extract-plugin
export var colorSquare = "_t4-0";
export var danger = "_t4-5";
export var lightPink = "_t4-8";
export var neutralBlue = "_t4-7";
export var neutralYellow = "_t4-6";
export var normal = "_t4-1";
export var primary = "_t4-2";
export var primaryLight = "_t4-3";
export var solidBlack = "_t4-g";
export var solidGreen = "_t4-b";
export var solidLightBlue = "_t4-d";
export var solidNavy = "_t4-c";
export var solidOrange = "_t4-f";
export var solidPink = "_t4-e";
export var solidRed = "_t4-9";
export var solidYellow = "_t4-a";
export var success = "_t4-4";